<template>
  <div v-if="!!normalisedItems">
    <table class="styled-table" >
      <tr>
        <th>{{$t('type')}}</th>
        <th class="col-bordered border-good good">{{$t('good')}}</th>
        <th/>
        <th class="col-bordered border-bad bad">{{$t('bad')}}</th>
        <th/>
        <th>{{$t('active')}}</th>
      </tr>
      <tr v-for="type in types" :key="type">
        <td>
          {{$t(type)}}
        </td>
        <td class="col-bordered border-good">
          <span v-if="normalisedItems[type].green1 || normalisedItems[type].green2">
            <span v-if="normalisedItems[type].green1">
                {{$t('from')}} <input type="text" v-model="normalisedItems[type].green1.value" class="input-tiny" style="margin-right: 1rem"/>
              </span>
            <span v-if="normalisedItems[type].green2">
                {{$t('to')}} <input type="text" v-model="normalisedItems[type].green2.value" class="input-tiny"/>
            </span>

          </span>
        </td>
        <td/>
        <td class="col-bordered border-bad">
          <span v-if="normalisedItems[type].red1 || normalisedItems[type].red2">
            <span v-if="normalisedItems[type].red1">
                {{$t('below')}} <input type="text" v-model="normalisedItems[type].red1.value" class="input-tiny"/>
              </span>
            <span v-if="normalisedItems[type].red2">
                {{$t('above')}} <input type="text" v-model="normalisedItems[type].red2.value" class="input-tiny"/>
            </span>

          </span>
        </td>
        <td/>
        <td>
          <switches v-model="normalisedItems[type].active" theme="bootstrap" color="success" @input="onChangeActive(normalisedItems[type])"></switches>
        </td>

      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TrafficLightsAlarmsSettings',
  props: {
    value: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      normalisedItems: null,
    }
  },
  mounted() {
    this.normalizeItems()
  },
  watch: {
    value() {
      this.normalizeItems()
    },
  },
  computed: {
    types() {
      return this.value.reduce((a, x) => {
        if (!a.includes(x.type)) a.push(x.type)
        return a
      }, [])
    },
  },
  methods: {
    getItem(type, logic, level) {
      let result = this.value.find(x => x.type === type && x.logic === logic && (x.level || 2) === level)
      if (!result && level === 1) {
        const constLevel2Item = this.value.find(x => x.type === type && x.logic === logic && (x.level || 2) === 2)
        if (constLevel2Item) {
          result = {...constLevel2Item, value: null, level: 1}
          this.value.push(result);
        }
      }
      return result
    },
    normalizeItems() {
      const result = {}
      this.types.forEach(x => {
        result[x] = {
          green1: this.getItem(x, '<', 1),
          green2: this.getItem(x, '>', 1),
          red1: this.getItem(x, '<', 2),
          red2: this.getItem(x, '>', 2),
        }
        let active = true
        for (const k in result[x]) {
          active = active && (!result[x][k] || result[x][k].active)
        }
        result[x] = {
          ...result[x],
          active
        }
        // if (result[x].red1) result[x].red1.level = undefined
        // if (result[x].red2) result[x].red2.level = undefined
      })
      this.normalisedItems = result
    },
    onChangeActive(it) {
      for (const itKey in it) {
        if (itKey === 'active') continue;
        if (it[itKey]) this.$set(it[itKey], 'active', it.active)
      }
    }
  },

}
</script>

<style scoped>
.styled-table {
  white-space: nowrap;
}
.good {
  color: lightgreen;
}
.bad {
  color: red;
}
.border-good {
  border: 4px solid lightgreen;
}
.border-bad {
  border: 4px solid red;
}
table th+.col-bordered {
  border-bottom:0;
  width: 10%;
  min-width: 16rem;
}
table tr:not(:last-child) td+.col-bordered {
  border-bottom:0;
  border-top:0;
}
table tr:last-child td+.col-bordered {
  border-top:0;
}

</style>



// WEBPACK FOOTER //
// src/components/TrafficLightsAlarmsSettings.vue